import React from 'react'

export interface dropdownOptionWithClickInterface {
  label: string
  value: string
  style?: React.CSSProperties
  disabled?: boolean
  onClick: () => void
}
export const reportTypeObj = {
  incidentReport: 'Incident Report',
  scheduledReport: 'Scheduled Report',
}
export const scheduledReportTypeObj = {successful: 'Successful Scans', missed: 'Missed Scans'}
